// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__1xV2u"};